import baseInput from './base-input.vue'

export default {
  install: function(Vue) {
    Vue.component('baseInput', baseInput)
  }
}